import * as React from 'react';
import styled from '../../../styled-components';

const Wrapper = styled.div`
    margin-top: 0.5em;
`;

interface VacancyQuestionProps {
    question: string;
    onChange: (question: string) => void;
}

class VacancyQuestion extends React.Component<VacancyQuestionProps, {}> {
    private inputRef: React.RefObject<HTMLTextAreaElement>;

    constructor(props: VacancyQuestionProps) {
        super(props);
        this.inputRef = React.createRef();
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    private changeQuestion(text: string) {
        if (this.props.question !== text) {
            this.props.onChange(text);
            if (this.props.question === '' && this.inputRef.current) {
                this.inputRef.current.value = '';
                this.inputRef.current.focus();
            }
        }
    }

    private handleOnChange(event) {
        const text = event.currentTarget.value;
        this.changeQuestion(text);
    }

    private handleKeyPress = e => {
        if (this.inputRef.current) {
            if (e.key === 'Enter') {
                this.changeQuestion(this.inputRef.current.value);
            } else if (e.keyCode === 27) {
                // on esc pressed
                this.inputRef.current.value = this.props.question;
            }
        }
    };

    public render() {
        const placeholder = this.props.question === '' ? 'Type to add next question...' : 'Remove this question';
        return (
            <Wrapper>
                <textarea
                    ref={this.inputRef}
                    defaultValue={this.props.question}
                    onBlur={this.handleOnChange}
                    onKeyPress={this.handleKeyPress}
                    onKeyDown={this.handleKeyPress}
                    placeholder={placeholder}
                    style={{ width: '100%' }}
                />
            </Wrapper>
        );
    }
}

export default VacancyQuestion;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/VacancyQuestion.tsx